import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import useDriftClient from '../useDriftClient';
import useDriftClientIsReady from '../useDriftClientIsReady';
import { useQuery } from '@tanstack/react-query';

export function isSignedMsgUserOrdersAccountInitializedQueryKey(
	walletPublicKeyBase58?: string
) {
	return ['isSignedMsgUserOrdersAccountInitialized', walletPublicKeyBase58];
}

/**
 * Note, will return `undefined` if the user's account does not yet exist.
 */
export const useIsSignedMsgUserOrdersAccountInitialized = () => {
	const driftClient = useDriftClient();
	const driftClientIsReady = useDriftClientIsReady();
	const authority = useDriftAccountStore(
		(s) => s.getCurrentUserAccount()?.authority
	);
	const userAccountExists = useDriftAccountStore(
		(s) => !!s.getCurrentUserAccount()
	);

	const isDisabled =
		!driftClient || !driftClientIsReady || !authority || !userAccountExists;

	return useQuery({
		queryKey: isSignedMsgUserOrdersAccountInitializedQueryKey(
			authority?.toBase58()
		),
		queryFn: () => {
			if (isDisabled) {
				return;
			}

			return driftClient?.isSignedMsgUserOrdersAccountInitialized(authority);
		},
		enabled: !isDisabled,
		staleTime: Infinity,
	});
};
